export default "__VITE_ASSET__BeyF3NyV__"